import { Controller } from "@hotwired/stimulus"

// ElencoDettaglio di components/rendicontazione/ElencoDettaglio.js (31a5bd1): filtro e scelta sul posto.
// Elementi e dettagli li rende il server (_elenco_dettaglio); qui: i filtri (nelFiltro: «tutte» o il gruppo dell'elemento),
// il dettaglio scelto (quello scelto se visibile, altrimenti il primo visibile), sotto i 1024 px il dettaglio entra in
// vista. filtro e scelta (quella effettiva) si riportano in campi nascosti `filtro` e `scelta` di ogni form del pannello
// (il turbo-frame che contiene l'elenco), cosi' una scrittura li rimanda al server che li restituisce nel pannello riscritto.
export default class extends Controller {
  static targets = ["filtroBtn", "voce", "scelta", "dettaglio", "vuoto", "riquadro"]
  static values = { filtro: String, scelta: String }

  connect() {
    this.radice = this.element.closest("turbo-frame") || this.element
    this.alInvio = (e) => { if (e.target instanceof HTMLFormElement) this.specchia(e.target) }
    this.radice.addEventListener("submit", this.alInvio, true)
    this.applica()
  }

  disconnect() {
    this.radice?.removeEventListener("submit", this.alInvio, true)
  }

  filtra({ params: { k } }) {
    this.filtroValue = k
  }

  scegli({ params: { id } }) {
    this.sceltaValue = id
    if (window.innerWidth < 1024 && this.hasRiquadroTarget) {
      setTimeout(() => this.riquadroTarget.scrollIntoView?.({ behavior: "smooth", block: "start" }), 0)
    }
  }

  filtroValueChanged() { this.applica() }
  sceltaValueChanged() { this.applica() }

  applica() {
    if (!this.hasFiltroValue || !this.radice) return
    const nelFiltro = (gruppo) => this.filtroValue === "tutte" || this.filtroValue === gruppo
    const visibili = this.voceTargets.filter((li) => nelFiltro(li.dataset.gruppo))
    this.voceTargets.forEach((li) => { li.hidden = !visibili.includes(li) })
    const attivo = visibili.find((li) => li.dataset.id === this.sceltaValue) || visibili[0] || null
    const id = attivo ? attivo.dataset.id : ""
    this.voceTargets.forEach((li) => {
      const b = li.querySelector("[data-elenco-dettaglio-target~='scelta']")
      if (li === attivo) b?.setAttribute("aria-current", "true"); else b?.removeAttribute("aria-current")
    })
    this.dettaglioTargets.forEach((d) => { d.hidden = d.dataset.id !== id })
    this.filtroBtnTargets.forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.elencoDettaglioKParam === this.filtroValue)))
    this.vuotoTargets.forEach((el) => { el.hidden = visibili.length > 0 })
    this.radice.querySelectorAll("form").forEach((f) => this.specchia(f, id))
  }

  // filtro e scelta effettiva nei campi nascosti del form (creati se mancano)
  specchia(form, id = this.effettiva()) {
    this.campo(form, "filtro").value = this.filtroValue
    this.campo(form, "scelta").value = id
  }

  effettiva() {
    const li = this.voceTargets.find((x) => !x.hidden && x.querySelector("[aria-current='true']"))
    return li ? li.dataset.id : ""
  }

  campo(form, nome) {
    let c = Array.from(form.elements).find((e) => e.name === nome && e.dataset.elencoDettaglioSpecchio)
    if (!c) {
      c = document.createElement("input")
      c.type = "hidden"
      c.name = nome
      c.dataset.elencoDettaglioSpecchio = "1"
      form.appendChild(c)
    }
    return c
  }
}
